// total week shipment on dashboard
export const TOTAL_WEEK_SHIPMENT_LOADING = 'TOTAL_WEEK_SHIPMENT_LOADING';
export const TOTAL_WEEK_SHIPMENT_ERROR = 'TOTAL_WEEK_SHIPMENT_ERROR';
export const TOTAL_WEEK_SHIPMENT_DATA = 'TOTAL_WEEK_SHIPMENT_DATA';

// Get Today Loading Bookings
export const GET_LOADING_BOOKINGS_LOADING_DATA = 'GET_LOADING_BOOKINGS_LOADING_DATA';
export const GET_LOADING_BOOKINGS_DATA = 'GET_LOADING_BOOKINGS_DATA';
export const GET_LOADING_BOOKINGS_ERROR = 'GET_LOADING_BOOKINGS_ERROR';

// total year shipment on dashboard
export const TOTAL_YEAR_SHIPMENT_LOADING = 'TOTAL_YEAR_SHIPMENT_LOADING';
export const TOTAL_YEAR_SHIPMENT_ERROR = 'TOTAL_YEAR_SHIPMENT_ERROR';
export const TOTAL_YEAR_SHIPMENT_DATA = 'TOTAL_YEAR_SHIPMENT_DATA';

// Get Total Shipment Count based on Current Month

export const GET_TOTAL_CURRENT_MONTH_SHIPMENT_LOADING = 'GET_TOTAL_CURRENT_MONTH_SHIPMENT_LOADING';
export const GET_TOTAL_CURRENT_MONTH_SHIPMENT_ERROR = 'GET_TOTAL_CURRENT_MONTH_SHIPMENT_ERROR';
export const GET_TOTAL_CURRENT_MONTH_SHIPMENT_DATA = 'GET_TOTAL_CURRENT_MONTH_SHIPMENT_DATA';

// Get Chart Data based on Bookings and Container

export const GET_CHARTS_DATA = 'GET_CHARTS_DATA';
export const GET_CHART_DATA_LOADING = 'GET_CHART_DATA_LOADING';
export const GET_CHART_DATA_ERROR = 'GET_CHART_DATA_ERROR';

// Get Booking Chart Data Based On Supplier Location

export const GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_DATA =
	'GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_DATA';
export const GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_ERROR =
	'GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_ERROR';
export const GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_LOADING =
	'GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_LOADING';

// Get Container Counts Based on Booking Status

export const GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_DATA = 'GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_DATA';
export const GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_ERROR = 'GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_ERROR';
export const GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_LOADING =
	'GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_LOADING';

// Get Advanced Charts Data
export const GET_ADVANCED_BOOKING_COUNT_DATA = 'GET_ADVANCED_BOOKING_COUNT_DATA';
export const GET_ADVANCED_BOOKING_COUNT_ERROR = 'GET_ADVANCED_BOOKING_COUNT_ERROR';
export const GET_ADVANCED_BOOKING_COUNT_LOADING = 'GET_ADVANCED_BOOKING_COUNT_LOADING';

export const SET_SELECTED_TASKS_SCHEDULE = 'SET_SELECTED_TASKS_SCHEDULE';
export const GET_SELECTED_TASKS_SCHEDULE = 'GET_SELECTED_TASKS_SCHEDULE';
